// Faith 1st — Katrina Bernard portrait assets
// Hosted on Emergent customer-assets CDN
export const PHOTOS = {
  // IMG_0986 — Seated executive portrait at desk, b&w geometric pattern,
  // hands clasped. Formal, composed, executive presence.
  seatedFormal:
    "https://customer-assets.emergentagent.com/job_calm-authority-site/artifacts/q21e3hvz_IMG_0986.jpg",

  // IMG_0784 — Warm close head-and-shoulders portrait, muted pink background,
  // white ruffled blouse, soft warm smile. Approachable, relational.
  warmCloseUp:
    "https://customer-assets.emergentagent.com/job_calm-authority-site/artifacts/5pq3yzbx_IMG_0784.jpg",

  // IMG_0885 — Standing portrait, hand on chin, muted green background,
  // white blouse, contemplative warm smile. Confident + approachable.
  contemplative:
    "https://customer-assets.emergentagent.com/job_calm-authority-site/artifacts/3zkru2rp_IMG_0885.jpg",

  // IMG_0977 — Facilitation / conversation shot: two women in dialogue,
  // gesture in motion. Suggests the work in practice.
  facilitation:
    "https://customer-assets.emergentagent.com/job_calm-authority-site/artifacts/zt1hb2to_IMG_0977.jpg",
};
